import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { TIDS } from "@/constants/testIds";
import HeroGraphic from "./HeroGraphic";
import { ArrowRight, Sparkles } from "lucide-react";

const Hero = ({ onBookClick, onPackagesClick }) => {
  const { t } = useI18n();

  return (
    <section id="top" className="relative pt-28 md:pt-40 pb-16 md:pb-28 overflow-hidden">
      <div className="absolute inset-0 grid-bg pointer-events-none" />

      <div className="zdc-container relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 space-y-7 reveal">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#E5E7EB] bg-white/70 backdrop-blur-sm">
              <Sparkles className="w-3.5 h-3.5 text-[#2563EB]" />
              <span className="text-xs font-medium text-[#111111]">{t.hero.eyebrow}</span>
            </div>

            <h1
              data-testid={TIDS.heroTitle}
              className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-[68px] font-semibold tracking-tighter text-[#111111] leading-[1.05]"
            >
              {t.hero.title}
            </h1>

            <p className="text-base md:text-lg text-[#6B7280] leading-relaxed max-w-[560px]">
              {t.hero.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                data-testid={TIDS.heroCtaPrimary}
                onClick={onBookClick}
                className="btn-primary justify-center"
              >
                {t.hero.ctaPrimary}
                <ArrowRight className="w-4 h-4" />
              </button>
              <button
                data-testid={TIDS.heroCtaSecondary}
                onClick={onPackagesClick}
                className="btn-ghost justify-center"
              >
                {t.hero.ctaSecondary}
              </button>
            </div>

            <div className="flex items-center gap-3 pt-2 text-xs text-[#6B7280]">
              <div className="flex -space-x-2">
                <div className="w-7 h-7 rounded-full border-2 border-white bg-gradient-to-br from-[#2563EB] to-[#1d4ed8]" />
                <div className="w-7 h-7 rounded-full border-2 border-white bg-gradient-to-br from-[#111111] to-[#374151]" />
                <div className="w-7 h-7 rounded-full border-2 border-white bg-gradient-to-br from-[#10B981] to-[#059669]" />
              </div>
              <span>{t.hero.trustBadge}</span>
            </div>
          </div>

          <div className="lg:col-span-5 reveal reveal-delay-1">
            <HeroGraphic />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
